import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchReports } from "../../api/reports";

export function useFetchReports(page = 1, pageSize = 10, filters) {
  return useQuery({
    queryKey: ["reports", page, pageSize, filters?.reviewFilter, filters?.startDate, filters?.endDate],
    queryFn: () => fetchReports(page, pageSize, filters),
    placeholderData: keepPreviousData,
  });
}